import './index.css'
import { useEffect, useState } from "react"
import ActionModal from "../common/ActionModal"
import { DataEntity, EntityFormModel } from "../../models/entity.model"
import EntityForm from "./CustomFieldForm"
import ConfirmModal from "../common/ConfirmModal"
import { set, SubmitHandler } from "react-hook-form"
import { useProject } from "../../context/ProjectContext"
import { APIResponseModel } from "../../models/api-call"
import { useNotification } from '../../context/NotificationContext'
import { createTicketCustomField, deleteTicketCustomField, editTicketCustomField, filterTicketCustomFields, getTicketCustomField } from '../../services/ticket.service'
import { CustomFieldFormModel, DataCustomField } from '../../models/customField.model'
import CardDashboard from '../common/CardDashboard'
import Card from './Card'
import CustomFieldForm from './CustomFieldForm'
import { itemSelection } from '../../models/itemSelection.model'
import { getTicketCustomFieldTypes } from '../../services/autocomplete.service'


interface CustomFieldsListingProps {
  setBlockScreen: (p: any) => void
  setOpenActionModal: (p: any) => void
  openActionModal: boolean
  setAction: React.Dispatch<React.SetStateAction<any>>
  action: 'create' | 'edit' | 'view'
  canEdit: boolean
  project_id: string
}

export default function CustomFieldsListing({ setBlockScreen, setOpenActionModal, openActionModal,
  action, setAction, canEdit }: CustomFieldsListingProps) {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [loadingList, setLoadingList] = useState<boolean>(true)
  const [reloadList, setReloadList] = useState(false)

  const [customFieldCode, setCustomFieldCode] = useState<string>('')
  const clearSelection = () => setCustomFieldCode('')
  const [openConfirmModal, setOpenConfirmModal] = useState(false)

  const [fieldErrors, setFieldErrors] = useState<string[]>([])

  const initialForm: CustomFieldFormModel = {
    code: '',
    hname: '',
    created_date: '',
    default_value: '',
    type: { id: '', label: '' },
  }

  const [customFieldForm, setCustomFieldForm] = useState<CustomFieldFormModel>(initialForm)
  const [customFieldList, setCustomFieldList] = useState<DataCustomField[]>([])
  const [customFieldTypeList, setCustomFieldTypeList] = useState<itemSelection[]>([])


  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([getTicketCustomFieldTypes(selectedProject)
    ]).then(function (result: any[]) {
      setCustomFieldTypeList(result[0].data)
      setBlockScreen(false)
    }).catch((error) => {
      showNotification(<span>Error obteniendo lista de tipos de campos personalizados</span>, 'error')
      setBlockScreen(false)
    });
  }

  useEffect(initComponent, [])


  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | { 'target': { 'name': any, 'value': any } }): void => {
    setCustomFieldForm({
      ...customFieldForm,
      [event.target.name]: event.target.value
    });
  }


  const errorFields = () => {
    let errors: string[] = []
    if (customFieldForm.hname.length === 0) errors.push('hname')
    setFieldErrors(errors)

    return errors.length > 0
  }

  const handleCloseDetail = () => {
    setOpenActionModal(false)
    clearSelection()
    setAction('view')
    setCustomFieldForm(initialForm)
    setFieldErrors([])
  }

  const fetchDataDashboard = () => {
    setLoadingList(true)
    Promise.all([filterTicketCustomFields(selectedProject ? selectedProject : 'ALL', {})
    ]).then(function (result: APIResponseModel[]) {
      setCustomFieldList(result[0].data)
      setTimeout(() => { setLoadingList(false) }, 1500)
    }).catch((error) => {
      showNotification(<span>Error obteniendo la lista de campos personalizados</span>, 'error')
      setLoadingList(false)
    });
  };

  useEffect(fetchDataDashboard, [reloadList, selectedProject])

  const fetchCustomField = () => {
    if (customFieldCode === '') return
    setBlockScreen(true)
    Promise.all([getTicketCustomField(selectedProject ? selectedProject : 'ALL', customFieldCode)
    ]).then(function (result: APIResponseModel[]) {
      setCustomFieldForm(result[0].data)
      setOpenActionModal(true)
      setBlockScreen(false)
    }).catch((error) => {
      showNotification(<span>
        Error: {error.response.data.message ? error.response.data.message : error.response.data}
      </span>, 'error')
      setBlockScreen(false)
    });
  }

  useEffect(fetchCustomField, [customFieldCode])

  const onSubmitCreate: SubmitHandler<CustomFieldFormModel> = () => {
    if (!errorFields()) {
      setBlockScreen(true)
      Promise.all([createTicketCustomField(selectedProject, customFieldForm)
      ]).then(function (result: APIResponseModel[]) {
        setTimeout(() => {
          showNotification(<span>Se ha creado el campo personalizado <i>{customFieldForm.hname}</i></span>)
          handleCloseDetail()
          setReloadList(!reloadList)
        }, 1000)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>{error.response.data.message}</span>, 'error')
        setBlockScreen(false);
      });
    }
  }

  const onSubmitEdit: SubmitHandler<EntityFormModel> = () => {
    if (!errorFields()) {
      setBlockScreen(true)
      Promise.all([editTicketCustomField(selectedProject, customFieldCode, customFieldForm)
      ]).then(function (result: APIResponseModel[]) {
        setTimeout(() => {
          showNotification(<span>Se ha editado el campo personalizado <i>{customFieldForm.hname}</i></span>)
          handleCloseDetail()
          setReloadList(!reloadList)
        }, 1000)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>{error.response.data.message}</span>, 'error')
        setBlockScreen(false);
      });
    }
  }

  const onSubmitDelete = () => {
    setBlockScreen(true)
    Promise.all([deleteTicketCustomField(selectedProject ? selectedProject : 'ALL', customFieldCode)
    ]).then(function (result: APIResponseModel[]) {
      setTimeout(() => {
        showNotification(<span>Se ha removido el campo personalizado <i>{customFieldForm.hname}</i></span>)
        handleCloseDetail()
        setOpenConfirmModal(false)
        setReloadList(!reloadList)
      }, 1000)
      setBlockScreen(false)
    }).catch((error) => {
      showNotification(<span>{error.response.data.message}</span>, 'error')
      setOpenConfirmModal(false)
      setReloadList(!reloadList)
      setBlockScreen(false);
    });
  }

  const handleRemove = () => {
    setOpenConfirmModal(true)
  }

  const handleCloseConfirmRemove = () => {
    setOpenConfirmModal(false)
  }

  const handleClickDetail = (code: string) => {
    setCustomFieldCode(code)
  }

  useEffect(() => {
    if (action === 'create') handleChange({ target: { name: 'default_value', value: '' } })
  }, [customFieldForm.type.id])

  return (
    <>
      <ActionModal
        title={action === 'create' ? 'Nuevo Campo Personalizado' : 'Ver Campo Personalizado'}
        openModal={openActionModal}
        handleCloseModal={handleCloseDetail}
        mode={action}
        setMode={setAction}
        handleCreate={onSubmitCreate}
        handleEdit={onSubmitEdit}
        handleRemove={handleRemove}
        canEdit={canEdit && (true)}
        children={
          <>
            <CustomFieldForm
              customFieldForm={customFieldForm}
              handleChange={handleChange}
              customFieldTypeList={customFieldTypeList}
              action={action}
              errors={fieldErrors}
              editable={true}
            />
          </>
        }
      />

      <ConfirmModal
        openModal={openConfirmModal}
        handleCloseModal={handleCloseConfirmRemove}
        handleConfirm={onSubmitDelete}
      >
        <p>¿ Remover Campo Personalizado {customFieldForm.hname} ?</p>
      </ConfirmModal>

      <CardDashboard
        cards={
          customFieldList.map((field: DataCustomField, index: number) => (
            <Card
              key={index} formData={field}
              handleClickDetail={handleClickDetail} />
          ))
        }
        loading={loadingList}
      />
    </>
  );
}
